(function () {
  function setHeaderHeightVar() {
    var header = document.querySelector('header, .shopify-section-header, #shopify-section-header');
    var h = header ? header.offsetHeight : 0;
    document.documentElement.style.setProperty('--ch-header-h', h + 'px');
  }

  // direct, op resize & op editor events
  setHeaderHeightVar();
  window.addEventListener('load', setHeaderHeightVar);
  window.addEventListener('resize', setHeaderHeightVar);

  // Als er een sticky header is die class toggelt bij scroll, ook even checken:
  let prev = 0;
  setInterval(function(){
    var header = document.querySelector('header, .shopify-section-header, #shopify-section-header');
    if (!header) return;
    var now = header.offsetHeight;
    if (now !== prev) { prev = now; setHeaderHeightVar(); }
  }, 400);
})();
